export const LOGIT_INTERCEPTS = {
    1: -0.5761329793228842,
    2: -2.368184740063184,
    3: -3.41971992959559,
    4: -1.4676598757016663,
    5: -1.8970043366503462,
    6: -2.4893973975108814,
    7: -2.346385585270206,
    8: -2.8618972107198513,
    9: -3.9361796097780917,
    10: -3.491513388315017,
    11: -3.074356095009461,
    12: -2.282386017374551,
    13: -1.6052048049768997,
    14: -2.59305241578336,
    15: 0.0,
    16: -1.2997068210421088,
    17: -1.1035477768089679,
    18: -2.24343021361662,
    19: -0.5712962588459399,
    20: -1.6274568592918455,
};
export const LOGIT_PFA = {
    1: 0.1529146493067107,
    2: 0.2512970319739182,
    3: 0.22821935406282662,
    4: 0.19048525716208403,
    5: 0.2664863173378038,
    6: 0.29321349409320585,
    7: 0.24745459186779256,
    8: 0.2788048760557372,
    9: 0.37115976913185283,
    10: 0.2123147541413993,
    11: 0.1518993422799688,
    12: 0.21017625792257552,
    13: 0.20982954243744056,
    14: 0.24286457514986884,
    15: 0.2811560542160083,
    16: 0.18930680206808245,
    17: 0.15919082452813657,
    18: 0.1877275318822204,
    19: 0.2538545574554489,
    20: 0.2817583921253096,
};
export const LOGIT_NFA = {
    1: 0.4565586981754004,
    2: 0.31371321939148905,
    3: 0.3031476114559016,
    4: 0.5390886428116567,
    5: 0.3537114517776025,
    6: 0.42119898901725966,
    7: 0.27507557375674446,
    8: 0.30037131735959216,
    9: 0.21908595101185696,
    10: 0.3780901771647372,
    11: 0.41888330605913704,
    12: 0.46660531696163,
    13: 0.4940099449641958,
    14: 0.33706875551556675,
    15: 0.513096673953706,
    16: 0.42351010364702524,
    17: 0.46244130741160094,
    18: 0.47480241053094235,
    19: 0.41642725610259085,
    20: 0.3587716915995775,
};
export const LOGIT_IS_POS2 = {
    1: 0.031511575591160516,
    2: 0.06682186011213634,
    3: 0.2541235876801944,
    4: 0.2871283161543374,
    5: 0.2420483250305589,
    6: 0.26493130127559145,
    7: 0.3246685144761049,
    8: -0.08350602202096005,
    9: 0.22070494191920942,
    10: 0.41821758674336273,
    11: 0.5573665160823129,
    12: 0.28136848288030275,
    13: 0.35242631719060247,
    14: 0.2524611764459635,
    15: 0.12067849180131301,
    16: 0.06655662533049213,
    17: 0.047783732955830854,
    18: 0.3722944608522522,
    19: 0.20070524469426468,
    20: 0.08637781896890982,
};
export const LOGIT_IS_POS3 = {
    1: 0.31065122408035684,
    2: 0.425449692698024,
    3: 0.608658585321756,
    4: 0.5681096581244877,
    5: 0.5626577096922005,
    6: 0.3985680276236629,
    7: 0.6002072864350889,
    8: 0.11614042969731504,
    9: 0.5503007929853929,
    10: 0.7865301392683094,
    11: 0.5868512081793612,
    12: 0.555377282334211,
    13: 0.5136492622807787,
    14: 0.4941880030137364,
    15: 0.4106679844602398,
    16: 0.34614537684145996,
    17: 0.24344918979359254,
    18: 0.6547326959831749,
    19: 0.5185703194714832,
    20: 0.5666516241872317,
};
export const LOGIT_IS_POS4 = {
    1: 0.484008556458278,
    2: 0.6559429676984554,
    3: 0.8159262480745983,
    4: 0.8640963325738771,
    5: 0.8180086024000943,
    6: 0.6941702201657441,
    7: 0.8204039590706689,
    8: 0.5704869668526161,
    9: 0.9774651259006628,
    10: 1.0100316187861451,
    11: 1.04040230566829,
    12: 0.9608921161467455,
    13: 0.9206176146981673,
    14: 0.7333104764780539,
    15: 0.5323324005654451,
    16: 0.7217471086889646,
    17: 0.5136105993948795,
    18: 0.9429018487149614,
    19: 0.7436936147918674,
    20: 0.8403026761505435,
};
